import { PerkTile, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

export const { media } = theme;

export const ItemsWrapper = styled.div`
  display: grid;
  row-gap: 1rem;

  @media (min-width: ${media.md}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StyledPerkTile = styled(PerkTile)`
  max-width: none;

  @media (min-width: ${media.xl}) {
    width: 26rem;
  }

  & > img {
    height: 200px;
  }

  & > div {
    min-height: unset;
  }

  & > p {
    margin-bottom: 2rem;
    min-height: 3rem;
  }
`;

export const TileWrapper = styled.div`
  margin: 0 0 2rem;

  @media (min-width: ${media.md}) {
    margin: 0 1rem;
  }
`;
